module.exports = __webpack_public_path__ + "assets/ziyuan_2.50833ea8.svg";